class AnnurMotion {
  constructor(root = document) {
    this.root = root;
    this.observer = null;
  }

  init() {
    const elements = [...this.root.querySelectorAll('[data-annur-reveal]:not([data-annur-motion-ready])')];
    if (!elements.length) return;

    elements.forEach((element) => element.setAttribute('data-annur-motion-ready', ''));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    );

    elements.forEach((element) => this.observer.observe(element));
  }
}

const initializeAnnurMotion = (root = document) => new AnnurMotion(root).init();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAnnurMotion());
} else {
  initializeAnnurMotion();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeAnnurMotion(event.target));
}
